module.exports = __webpack_public_path__ + "assets/img/人工智能赋能.8712e98b.jpg";